export interface CreditInfoExchangeAlertDialogResult {
  proceed: boolean;
}

